import styles from './EditableTableList.module.scss';
export const isEmptyValue = (value)=>value == null || value === '' || value === false;
const NO_BI = true;
export const buttonBi = (config)=>config != null ? {
        bi: config
    } : {
        noBi: NO_BI
    };
export const resolveReorderIndices = (rowIds, event)=>{
    const { active, over } = event;
    if (over == null || active.id === over.id) return null;
    const fromIndex = rowIds.indexOf(String(active.id));
    const toIndex = rowIds.indexOf(String(over.id));
    if (fromIndex === -1 || toIndex === -1) return null;
    return {
        fromIndex,
        toIndex
    };
};
const ESTIMATED_CHAR_WIDTH_PX = 8;
const CELL_CHROME_WIDTH_PX = 32;
export const estimateColumnWidth = (values, param)=>{
    let { minWidth } = param;
    const longestValueLength = values.reduce((longest, value)=>Math.max(longest, value.length), 0);
    return Math.max(longestValueLength * ESTIMATED_CHAR_WIDTH_PX + CELL_CHROME_WIDTH_PX, minWidth);
};
export const columnWidthClass = (column)=>{
    if (column.grow) return styles.growColumn;
    if (column.width != null || column.maxWidth != null) return styles.cappedColumn;
    return styles.shrinkColumn;
};
export const columnWidthStyle = (column)=>{
    if (column.width != null) return {
        width: column.width,
        minWidth: column.width,
        maxWidth: column.width
    };
    return column.maxWidth != null ? {
        maxWidth: column.maxWidth
    } : undefined;
};
